/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ScanInfoResponseDTO interface.
 */
export function instanceOfScanInfoResponseDTO(value) {
    return true;
}
export function ScanInfoResponseDTOFromJSON(json) {
    return ScanInfoResponseDTOFromJSONTyped(json, false);
}
export function ScanInfoResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'] == null ? undefined : json['url'],
        'marketplaceId': json['marketplaceId'] == null ? undefined : json['marketplaceId'],
        'lastScanDate': json['lastScanDate'] == null ? undefined : (new Date(json['lastScanDate'])),
    };
}
export function ScanInfoResponseDTOToJSON(json) {
    return ScanInfoResponseDTOToJSONTyped(json, false);
}
export function ScanInfoResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'marketplaceId': value['marketplaceId'],
        'lastScanDate': value['lastScanDate'] == null ? undefined : ((value['lastScanDate']).toISOString()),
    };
}
